var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52832 6.78532V5.09969C2.52832 4.65263 2.70591 4.22389 3.02203 3.90777C3.33815 3.59165 3.76689 3.41406 4.21395 3.41406H5.89958",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3279 3.41406H16.0135C16.4606 3.41406 16.8893 3.59165 17.2054 3.90777C17.5215 4.22389 17.6991 4.65263 17.6991 5.09969V6.78532",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6991 15.2148V16.9005C17.6991 17.3475 17.5215 17.7763 17.2054 18.0924C16.8893 18.4085 16.4606 18.5861 16.0135 18.5861H14.3279",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89958 18.5861H4.21395C3.76689 18.5861 3.33815 18.4085 3.02203 18.0924C2.70591 17.7763 2.52832 17.3475 2.52832 16.9005V15.2148",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1139 13.5295C11.5103 13.5295 12.6423 12.3975 12.6423 11.0011C12.6423 9.60468 11.5103 8.47266 10.1139 8.47266C8.71747 8.47266 7.58545 9.60468 7.58545 11.0011C7.58545 12.3975 8.71747 13.5295 10.1139 13.5295Z",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4851 14.3748L11.8838 12.7734",
    stroke: "#888A8E",
    strokeWidth: 1.68563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/ScanIcon.43ad59113eb4a7be800b5979c078318f.svg";
export { ForwardRef as ReactComponent };